import { initializeSentry } from "@/lib/sentry";

void initializeSentry();
